import { Component, OnDestroy, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
declare var $: any;

import { SettingsService } from './core/settings/settings.service';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Repository } from './services/repository';

import { Global } from './shared/global';
import {  ToasterConfig } from 'angular2-toaster/angular2-toaster';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.layout.isFixed; };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.layout.isCollapsed; };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.layout.isBoxed; };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.layout.useFullLayout; };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.layout.hiddenFooter; };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.layout.horizontal; };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.layout.isFloat; };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.layout.offsidebarOpen; };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.layout.asideToggled; };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.layout.isCollapsedText; };
    private sub: any;

    toasterConfig: any;
    toasterconfig: ToasterConfig = new ToasterConfig({
        positionClass: 'toast-top-right',
        //timeout: 10000,
        showCloseButton: false
    });

    constructor(private slimLoader: SlimLoadingBarService, private router: Router, public settings: SettingsService,
        public repo: Repository
    )
    {
        var subtime: Subscription;

        
       
        this.sub = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                
                console.log("start loadder");
                this.slimLoader.start();
                this.slimLoader.progress = 50;
                $('#loading').hide();
                setTimeout(() => {
                    if (this.slimLoader.progress < 100 && this.slimLoader.progress != 0)
                        this.slimLoader.progress = 70;

                    console.log("gan 70");
                }, 400)

            } else if (event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError) {
              
               

                console.log("complete loadder");
                this.slimLoader.complete();
                
            }
        }, (error: any) => {
            console.log("error loadder");
            this.slimLoader.complete();
        });
    }

    ngOnInit() {
        $(document).on('click', '[href="#"]', e => e.preventDefault());

        
    }
    ngOnDestroy(): any {
        this.sub.unsubscribe();
    }
}
